import { z } from '@hono/zod-openapi'

export const LaneIdSchema = z.enum(['mtss', 'sped', 's504', 'el', 'health']).openapi({
  example: 'sped',
  description: 'The five canonical service lanes',
})

export const LaneDefinitionSchema = z.object({
  id: LaneIdSchema,
  label: z.string().openapi({ example: 'Special Education' }),
  shortLabel: z.string().openapi({ example: 'SpEd' }),
  color: z.string().openapi({ example: 'var(--sped, #7B68EE)' }),
  emoji: z.string().openapi({ example: '📘' }),
  routeLabel: z.string().openapi({ example: 'special-education' }),
  isIDEA: z.boolean().openapi({ example: true }),
  isSection504: z.boolean().openapi({ example: false }),
  isTitleIII: z.boolean().openapi({ example: false }),
}).openapi('LaneDefinition', { description: 'A single service lane definition' })

export const LaneConfigSchema = z.object({
  lanes: z.array(LaneDefinitionSchema).length(5),
  defaultLane: LaneIdSchema,
  activeLanes: z.array(LaneIdSchema).min(1).max(5),
}).openapi('LaneConfig', { description: 'Runtime lane configuration for a district' })

export type LaneId = z.infer<typeof LaneIdSchema>
export type LaneDefinition = z.infer<typeof LaneDefinitionSchema>
export type LaneConfig = z.infer<typeof LaneConfigSchema>
